<div>
  <div>
    <ion-text color="primary"><h2>{{translationKey + ".help_dialog.title" | translate}}</h2></ion-text>
    <ion-text [innerHTML]="translationKey + '.help_dialog.text' | translate"></ion-text>
  </div>
  <div>
    <ion-text color="primary"><h2>{{"SUDOKU.help_dialog.mechanics.play.title" | translate}}</h2></ion-text>
    <ion-text [innerHTML]="'SUDOKU.help_dialog.mechanics.play.text' | translate"></ion-text>
  </div>
  <div>
    <ion-text color="primary"><h2>{{"SUDOKU.help_dialog.mechanics.notes.title" | translate}}</h2></ion-text>
    <ion-text [innerHTML]="'SUDOKU.help_dialog.mechanics.notes.text' | translate"></ion-text>
  </div>
  <div>
    <ion-text color="primary"><h2>{{"SUDOKU.help_dialog.mechanics.keyboard.title" | translate}}</h2></ion-text>
    <ion-text [innerHTML]="'SUDOKU.help_dialog.mechanics.keyboard.prefix' | translate"></ion-text>
    <ion-text>
      <div class="sudoku-help-special-keys">
        <div class="sudoku-special-key">
          <span class="sudoku-special-key-icon"><ion-icon name="toggle-sharp" size="large" color="primary"></ion-icon></span>
          <span class="sudoku-special-key-description">{{"SUDOKU.help_dialog.mechanics.keyboard.buttons.notes" | translate}}</span>
        </div>
        <div class="sudoku-special-key">
          <span class="sudoku-special-key-icon"><ion-icon name="color-wand-sharp" size="large" color="primary"></ion-icon></span>
          <span class="sudoku-special-key-description">{{"SUDOKU.help_dialog.mechanics.keyboard.buttons.joker" | translate}}</span>
        </div>
        <div class="sudoku-special-key">
          <span class="sudoku-special-key-icon"><ion-icon name="backspace-sharp" size="large" color="primary"></ion-icon></span>
          <span class="sudoku-special-key-description">{{"SUDOKU.help_dialog.mechanics.keyboard.buttons.delete" | translate}}</span>
        </div>
      </div>
    </ion-text>
    <ion-text>{{"SUDOKU.help_dialog.mechanics.keyboard.suffix" | translate}}</ion-text>
  </div>
</div>
